var e = document.createElement('div');
e.id = 'no-ad-blocker';
e.style.display = 'none';
document.body.appendChild(e);
